
import * as React from 'react'

import * as styles from './backgroundVideo.css'
import { replaceFilename } from '../../../utils/StringUtils'
import { BGVideoPlayer } from './bgVideoPlayer'
import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { isIE } from '../../../utils/Platform'

// import { Portal } from 'react-portal'

// import * as ArrowRight from './ArrowRight.svg'

interface IProps {
  videoUrl916: string
  videoUrl169: string
  active?: boolean
  isBg?: boolean
}

@injectStores
@observer
export class BackgroundVideo extends StoreComponent<IProps & React.HTMLAttributes<HTMLDivElement>> {
  static defaultProps: Partial<IProps> = {
    active: true
  }

  render () {
    let src = this.props.videoUrl916

    if (this.store.breakpoints.desktop) {
      src = this.props.videoUrl169
    }

    return (
      // <Portal node={document && document.getElementById('app-background')} >
      <div className={styles.background}
        style={this.props.isBg ? { backgroundImage: `url('${replaceFilename(src, 'firstframe.jpg')}')` } : undefined}
      >

     <div className={styles.backgroundPlaceholder}>
       {this.props.active && !isIE && <BGVideoPlayer src={src} isBg={this.props.isBg || false}/>}
       </div>
     </div>
     // </Portal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/video/backgroundVideo.tsx